export const ValidationPopupContentTitle = ({
  titleText,
}: {
  titleText: string;
}) => {
  return (
    <h3 className="text-2xl font-semibold text-indigo-600">{titleText}</h3>
  );
};
